import fields from './field'
import { Field } from '@/types/partnerConfig'

const familyMemberDateOfBirthField: Field = {
  ...fields.DATE_OF_BIRTH,
  labelKey: 'familyPageDateOfBirthLabel',
  props: {
    // For adding family members, we only care about any date that's before now.
    maxDate: new Date(),
  },
}

const familyMemberGenderField: Field = {
  ...fields.GENDER,
  labelKey: 'familyPageGenderLabel',
}

const familyMemberFields = {
  GBR: [
    fields.FIRST_NAME,
    fields.LAST_NAME,
    familyMemberGenderField,
    familyMemberDateOfBirthField,
  ],
  USA: [
    fields.FIRST_NAME,
    fields.LAST_NAME,
    {
      ...fields.ZIPCODE,
      name: 'address_post_code', // Family member input accepts this instead
    },
    familyMemberDateOfBirthField,
  ],
}

export {
  familyMemberFields,
  familyMemberDateOfBirthField,
  familyMemberGenderField,
}
